<template>
  <div class="side-video-card" :title="video.title">
    <router-link :to="`/video/${video.videoId}`" class="card-link">
      <div class="thumb-wrapper">
        <el-image
          lazy
          fit="cover"
          :src="video.coverUrl"
          class="cover-img"
        >
          <div slot="placeholder" class="image-slot">
            <i class="el-icon-picture-outline" />
          </div>
        </el-image>

        <div class="badge-tag left-top">
          <i v-if="video.horizontal" class="el-icon-monitor" />
          <i v-else class="el-icon-mobile-phone" />
        </div>

        <div class="badge-tag right-bottom">
          {{ video.duration }}
        </div>
      </div>

      <div class="content-wrapper">
        <h4 class="video-title">{{ video.title }}</h4>

        <div class="video-info">
          <router-link :to="`/user/${video.user.userId}`" class="up-name">
            <i class="el-icon-user" />
            <span>{{ video.user.screenName }}</span>
          </router-link>

          <div class="stats-row">
            <span><i class="el-icon-video-play" /> {{ video.view }}</span>
            <span><i class="el-icon-chat-dot-round" /> {{ video.comment }}</span>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'SideVideoCard',
  props: {
    video: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.side-video-card {
  margin-bottom: 12px;
  border-radius: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
    .video-title {
      color: #409EFF;
    }
    .cover-img {
      transform: scale(1.05);
    }
  }
}

.card-link {
  display: flex;
  text-decoration: none;
  padding: 4px;
}

/* 左侧图片区域 */
.thumb-wrapper {
  position: relative;
  width: 140px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  background-color: #f0f2f5;

  .cover-img {
    width: 100%;
    height: 100%;
    transition: transform 0.5s;
  }

  .image-slot {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #909399;
    font-size: 20px;
  }
}

/* 浮层标签 */
.badge-tag {
  position: absolute;
  padding: 2px 4px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  border-radius: 4px;
  z-index: 1;

  &.left-top {
    top: 4px;
    left: 4px;
    background: rgba(0, 0, 0, 0.4);
  }

  &.right-bottom {
    bottom: 4px;
    right: 4px;
  }
}

/* 右侧文字内容区域 */
.content-wrapper {
  flex: 1;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0; // 保证 text-overflow 生效
}

.video-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #1f2f3d;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2; // 两行省略
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: color 0.2s;
}

.video-info {
  .up-name {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #909399;
    font-size: 12px;
    margin-bottom: 4px;

    &:hover {
      color: #409EFF;
    }

    i {
      margin-right: 4px;
    }

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.stats-row {
  display: flex;
  gap: 12px;
  color: #99a2aa;
  font-size: 12px;

  i {
    margin-right: 3px;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .thumb-wrapper {
    width: 120px;
    height: 70px;
  }

  .video-title {
    font-size: 13px;
    -webkit-line-clamp: 2;
  }
}
</style>
